import { ReactNode } from 'react'

export enum Method
{
    Post   = "POST",
    Get    = "GET",
    Delete = "DELETE"
}

export interface Parameter
{
    name        : string;
    description : ReactNode;
    optional    : boolean;
    type        : string;
    default?    : string;
};

export interface Example
{
    url           : string;
    body?         : object;
    output?       : object[];
    title?        : string;
    responseType? : ParameterType;
    codeCurl      : string;
    codePython    : string;
    codeJavaScript: string;
}

export interface EndPointDoc
{
    title          : string;
    url            : string;
    method         : Method;
    docurl         : string;
    description    : ReactNode;
    seoDescription : string;
    parameters?    : Parameter[];
    examples?      : Example[];
}

export enum Type
{
    Basic,
    Object,
    Array,
    Enum
}

export interface EnumMember
{
    id          : string;
    name        : string;
    description : ReactNode;
}

export interface ParameterType
{
    id           : string;
    name         : string;
    description  : ReactNode;
    type         : Type;
    childType?   : ParameterType;
    enumMembers? : EnumMember[];
    parameters?  : Parameter[];
}

